import script from "./File.vue?vue&type=script&setup=true&lang=js"
export * from "./File.vue?vue&type=script&setup=true&lang=js"

import "./File.vue?vue&type=style&index=0&id=7571d90f&lang=less"

const __exports__ = script;

export default __exports__